export const Bio = {
    name: "Shubham Lahoti",
    roles: [
      "iOS App developer",
      "Software Engineer"
    ],
    description: " 👋 Hi, I'm Shubham Lahoti – a passionate iOS App Developer with over 2 years of experience in the exciting world of software engineering! 💻📱\n🌟 My expertise includes crafting sleek, high-performing apps using SwiftUI, Swift, UIKit, Core Data, SwiftData, and Combine. I specialize in building scalable, maintainable solutions with a strong focus on MVVM architecture 🛠️✨.\n🚀 One of my proudest achievements was developing and launching a fully-functional events-dating app on the App Store for a client, where I handled everything from concept to deployment. This experience honed my skills in end-to-end app development, API integration, and performance optimization.\n🔧 Beyond iOS, I’m a tech enthusiast with a knack for versatility! I’ve worked with ReactJS, JavaScript, Node.js, Express.js, and MongoDB. With a strong foundation in Data Structures and Algorithms (DSA), I excel at solving complex challenges.\n💡 Whether it's building intuitive mobile experiences or exploring full-stack solutions, I thrive on learning and adapting to new technologies to deliver impactful software solutions. Let’s create something amazing together! 🚀🔥",
    github: "https://github.com/shubhamlahoti01",
    resume:
      "https://drive.google.com/file/d/1ehYN5z65TI1X3Kxp7jr6483IDz2FK2QP/view?usp=share_link",
    linkedin: "https://www.linkedin.com/in/shubham-lahoti/",
    twitter: "https://www.instagram.com/shubhamlahoti1/",
    insta: "https://www.instagram.com/shubhamlahoti1/",
    facebook: "https://www.instagram.com/shubhamlahoti1/",
  };
  
  export const skills = [
    {
      title: "iOS App Development",
      skills: [
        {
          "name": "Swiftui",
          "image": "https://techreflect.org/wp-content/uploads/2020/03/unnamed.png"
        },
        {
          "name": "Swift",
          "image": "https://developer.apple.com/swift/images/swift-og.png"
        },
        {
          "name": "Core Data",
          "image": "https://cdn-icons-png.flaticon.com/512/9850/9850812.png"
        },
        {
          "name": "Combine",
          "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCiqRdmTuSLIj4WgZ8QXG09Zy9ap1BoKd1aA&s"
        },
        {
          "name": "Swift Data",
          "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHmGMpMPkTHaBTioBHzmoi-54uZ8URlGFNIQ&s"
        },
        {
          "name": "UiKit",
          "image": "https://developer.apple.com/assets/elements/icons/uikit/uikit-96x96_2x.png"
        }
      ]
    },    
    {
      title: "Frontend web",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
            name: "React Native",
            image:
              "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
          },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
      title: "Programming Languages",
      skills: [
        {
          name: "Swift",
          image:
            "https://techreflect.org/wp-content/uploads/2020/03/unnamed.png",
      },
        {
            name: "C++",
            image:
              "https://codeprogramming.org/wp-content/uploads/2022/01/C-Logo.wine_.png",
        },
        {
            name: "Javascript",
            image:
              "https://cdn.pixabay.com/photo/2015/04/23/17/41/javascript-736400_1280.png",
        },
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
        },
        {
          name: "Figma",
          image:
            "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
        },
      ],
    },
  ];

  export const experiences = [
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/v2/C510BAQGWzR3tLzWoew/company-logo_200_200/company-logo_200_200/0/1630575763472/springrole_logo?e=1744243200&v=beta&t=nNN45N9P0bp7veKtIeyoN-JYdZNdmuWvJK5CSbZgg5Y",
      role: "Software Engineer 1",
      company: "Springworks",
      date: "Jun 2024 - Present",
      desc: "iOS App Developer at Springworks, where I’ve contributed to building and enhancing mobile applications like BURST and Horizon 360/Toro. My work focuses on developing robust, user-friendly features using SwiftUI, UIKit, and Core Data, ensuring seamless experiences for users. Throughout my time at Springworks, I've played a key role in delivering high-quality iOS solutions, from concept to deployment, while continuously optimizing app performance and implementing new functionalities.",
      skills: [
        "iOS App development",
        "Swiftui",
        "Azure Devops",
        "Core data",
        "UiKit",
      ],
    },
    {
      id: 1,
      img: "https://media.licdn.com/dms/image/v2/C510BAQGWzR3tLzWoew/company-logo_200_200/company-logo_200_200/0/1630575763472/springrole_logo?e=1744243200&v=beta&t=nNN45N9P0bp7veKtIeyoN-JYdZNdmuWvJK5CSbZgg5Y",
      role: "Software Engineer Intern",
      company: "Springworks",
      date: "Sep 2023 - Jun 2024",
      desc: "iOS App Developer at Springworks, where I’ve contributed to building and enhancing mobile applications like BURST and Horizon 360/Toro. My work focuses on developing robust, user-friendly features using SwiftUI, UIKit, and Core Data, ensuring seamless experiences for users. Throughout my time at Springworks, I've played a key role in delivering high-quality iOS solutions, from concept to deployment, while continuously optimizing app performance and implementing new functionalities.",
      skills: [
        "iOS App development",
        "Swiftui",
        "Azure Devops",
        "Core data",
        "UiKit",
      ],
    },
  ];


  export const projects = [
    {
      id: 11,
      title: "AI Interview Platform",
      date: "Feb 2024",
      description:
        "AI powered Interview Platform to help students practice their Interviewing skills in whichever domain they want for their upcoming placement season.",
      image:
        "",
      tags: [
        "OpenAI GPT 3",
        "Google Cloud Vision",
        "React Js",
        "Node Js",
        "Express Js",
        "Redux",
        "MongoDB",
      ],
      category: "web app",
      github: "https://github.com/SachetVijay/AI-Interview-Platform",
      webapp: ":https://github.com/SachetVijay/AI-Interview-Platform",
    },
    {
      id: 9,
      title: "Classroom Management System",
      date: "Jan 2024",
      description:
        "Designed a Responsive and User friendly UI using ReactJs to implement Classroom Management System to devise 2 Authorisation. Programmed Backend using Flask integrated with MongoDb to built 12 Restful API end points to perform Files and Data Transfer. Dockerized the app by Containerisation and Docker Compose to provide 0 hassle app setup in any environment.",
      image:
        "https://github.com/SachetVijay/suplimentry-management-system/blob/main/frontend/ClassroomMangementSystem.png",
      tags: [
        "Docker",
        "React Js",
        "MongoDb",
        "Flask",
        "Rest APIs",
        "Redux",
      ],
      category: "web app",
      github: "https://github.com/SachetVijay/suplimentry-management-system",
      webapp: "https://vercel.com/sachetvijay/suplimentry-management-system-5qhc",
    },
    {
      id: 0,
      title: "Blockchain-Enabled Loyalty & Rewards System for E-commerce",
      date: "Aug 2023",
      description:
        "Developed a fully functional E-commerce platform with an integrated Loyalty and Reward System featuring well-defined tokenomics. Created a robust blockchain-enabled loyalty and rewards platform as part of a 2-week-long hackathon, Flipkart GRID. Utilized Solidity for smart contract development with flawless execution, enhanced frontend efficiency using Next.js, and utilized Node.js and Express.js for backend functionality, in conjunction with MongoDB for data management. Correctly implemented the solution onto the Polygon blockchain, incorporating fungible tokens to enhance transparency to boost user engagement with 100% remarkable outcomes.",
      image:
        "",
      tags: ["BlockChain", "Solidity", "Polygon BlockChain Network", "Ethers.js", "Next Js", "MongoDb", "Node Js", "Express Js", "Redux"],
      category: "mobile app",
      github: "https://github.com/Root-Grid/Root_Grid5.0",
      webapp: "https://github.com/Root-Grid/Root_Grid5.0",
    },
  ];
  

  export const education = [
    {
      id: 0,
      img: "https://www.lpu.in/lpu-assets/images/logo/logo.svg",
      school: "Lovely Professional University, Jalandhar Punjab",
      date: "Oct 2020 - June 2024",
      grade: "8.1 CGPA",
      desc: "I have completed my Bachelor's degree in Computer Science and Engineering from Lovely Professional University in Jalandhar, Punjab. During my academic journey, I focused on building expertise in Full Stack Web Development and iOS App Development, particularly with SwiftUI. I graduated in July 2024 with a CGPA of 8.1, and I am passionate about developing intuitive and high-performing applications across both mobile and web platforms.",
      degree: "Bachelor of Technology in Computer Science and Engineering",
    },
  ];
